import { Endpoint } from "../config";

export type DocumentEndpointType =
  | "documentMaster"
  | "viewDocumentMaster"
  | "viewOnboardedDocument"
  | "viewOnboardingDocumentHistory"
  | "viewHistoryDocument"
  | "updateOnboardingDocumentInputFields"
  | "updateOnboardingDocumentFinOb1InputFields"
  | "viewOnboardingDocumentFinOb1InputFields"
  | "documentApproval"
  | "documents"
  | "documentsDelete"
  | "myDriveDocuments"
  | "createFolder"
  | "myDriveDocumentList"
  | "imDocumentList"
  | "imDocumentListById"
  | "imDocumentListForFunder"
  | "imDocumentHistoryList"
  | "tsDocumentHistoryList"
  | "termSheetListT1T2"
  | "termSheetListT4"
  | "receivedTermSheetList"
  | "createdTermSheetList"
  | "sendTermSheet"
  | "deleteTermSheet"
  | "viewIMDocument"
  | "viewIMDocumentHistory"
  | "viewTSDocument"
  | "viewTSDocumentHistory"
  | "approveRejectIMTSDocument"
  | "revertTermSheet"
  | "sendIMDocument"
  | "revertIMDocument"
  | "updateFolder"
  | "folderDelete"
  | "documentsToBeApproved"
  | "filesTimeline"
  | "finOb1Timeline"
  | "addIMDocument"
  | "updateIMDocument"
  | "createTsDocument"
  | "addTsDocument"
  | "updateTsDocument"
  | "reuploadImDocument"
  | "reuploadTsDocument"
  | "filesUpload"
  | "fileSave"
  | "onBoardingSubmit"
  | "myDriveFiles"
  | "activeProfile"
  | "revertTermSheetDocument"
  | "sendTermSheetDocument";

export const documentEndpoints: Record<DocumentEndpointType, Endpoint> = {
  documentMaster: {
    url: "document-master/",
  },
  viewDocumentMaster: {
    url: "uploaded-document-list",
  },
  viewOnboardedDocument: {
    url: "view-document",
  },
  viewOnboardingDocumentHistory: {
    url: "document-history",
  },
  viewHistoryDocument: {
    url: "view-document-history",
  },
  updateOnboardingDocumentInputFields: {
    url: "document-input",
  },
  updateOnboardingDocumentFinOb1InputFields: {
    url: "document-input-fin-ob1/",
  },
  viewOnboardingDocumentFinOb1InputFields: {
    url: "view-fin-ob1/details",
  },
  documentApproval: {
    url: "document-approval/",
  },
  documents: {
    url: "documents/",
  },
  documentsDelete: {
    url: "documents",
  },
  myDriveDocuments: {
    url: "my-drive-documents/",
  },
  createFolder: {
    url: "folders/",
  },
  myDriveDocumentList: {
    url: "folder-content",
  },
  imDocumentList: {
    url: "im-document-list/",
  },
  imDocumentListById: {
    url: "im-document-list",
  },
  imDocumentListForFunder: {
    url: "im-document-list-for-funder/",
  },
  imDocumentHistoryList: {
    url: "im-document-history-list",
  },
  tsDocumentHistoryList: {
    url: "ts-document-history-list",
  },
  termSheetListT1T2: {
    url: "ts-document-list-for-funder/",
  },
  termSheetListT4: {
    url: "ts-document-list/",
  },
  receivedTermSheetList: {
    url: "received-ts-document-list/",
  },
  createdTermSheetList: {
    url: "created-ts-document-list/",
  },
  sendTermSheet: {
    url: "send-ts-document",
  },
  deleteTermSheet: {
    url: "delete-ts-document",
  },
  viewIMDocument: {
    url: "view-im-document",
  },
  viewIMDocumentHistory: {
    url: "view-im-document-history",
  },
  viewTSDocument: {
    url: "view-ts-document",
  },
  viewTSDocumentHistory: {
    url: "view-ts-document-history",
  },
  approveRejectIMTSDocument: {
    url: "im-ts-document-approval",
  },
  revertTermSheet: {
    url: "revert-ts-document",
  },
  sendIMDocument: {
    url: "send-im-document",
  },
  revertIMDocument: {
    url: "revert-im-document",
  },
  updateFolder: {
    url: "folder-rename",
  },
  folderDelete: {
    url: "folder-delete",
  },
  documentsToBeApproved: {
    url: "document-to-be-approved/",
  },
  filesTimeline: {
    url: "files-timeline",
  },
  finOb1Timeline: {
    url: "fin-ob1-timeline",
  },
  addIMDocument: {
    url: "add-im-document/",
  },
  updateIMDocument: {
    url: "add-im-document",
  },
  createTsDocument: {
    url: "create-ts-for-admin/",
  },
  addTsDocument: {
    url: "add-ts-document/",
  },
  updateTsDocument: {
    url: "add-ts-document",
  },
  reuploadImDocument: {
    url: "reupload-im-document",
  },
  reuploadTsDocument: {
    url: "re-upload-ts-document",
  },
  filesUpload: {
    url: "documents/generate-presigned-url/",
  },
  fileSave: {
    url: "documents/save/",
  },
  onBoardingSubmit: {
    url: "submit-document/",
  },
  myDriveFiles: {
    url: "files/save/",
  },
  activeProfile: {
    url: "update-default-profile/",
  },
  revertTermSheetDocument: {
    url: "revert-ts-document",
  },
  sendTermSheetDocument: {
    url: "send-ts-document",
  },
};
